export default __webpack_public_path__ + "static/media/modulus.a7b0bd7d.svg";